  import {Injectable} from '@angular/core';
  import { Meta } from '@angular/platform-browser';
  import { setting } from '../setting';
  import { ClientService } from './app/services/client.service';

  @Injectable()
export class SeoService {


  public faviconUrl = '';
  public routeUploadFile:any;
  private clientData: any;

  constructor(private meta: Meta, private clientService: ClientService) {
    // Se obtiene el título y el favicon de la base de datos (LocalStorage) y se guarda en las propiedades de la clase
     this.clientService.clientData$.subscribe((data) => {
            this.clientData = data;
      });

        // Si ya hay datos disponibles sincrónicamente
      if (this.clientService.getClientData()) {
            this.clientData = this.clientService.getClientData();
      }


    this.routeUploadFile = setting.routeUploadFile;
    this.faviconUrl = this.routeUploadFile+this.clientData?.clients_setting_global?.favicon;
  }

  setSeoData(description: string) {
    this.meta.updateTag({ name: 'description', content: description });
    this.meta.updateTag({ rel: 'icon', href: this.faviconUrl });
  }

  getFaviconUrl(): string {
    return this.faviconUrl;
  }


}
